import useDialog from "utils/hooks/useDialog";
import { Dialog } from 'primereact/dialog';
import Payments from 'components/Payments/Payments'
import { BannerButton } from "../Banner/styles";

const PaymentDialog = ({ label }) => {
  const [isDialogVisible, toggleDialogVisibility] = useDialog()

  return (
    <>
      <BannerButton onClick={toggleDialogVisibility} label={label} icon="pi pi-heart" iconPos="right" />
      <Dialog
        visible={isDialogVisible}
        onHide={toggleDialogVisibility}
        style={{ height: 'auto' }}
        header={label}
        draggable={false}
        resizable={false}
        blockScroll
        modal
      >
        {isDialogVisible && (
          <Payments />
        )}
      </Dialog>
    </>
  )
}

export default PaymentDialog
